"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginateAnything = void 0;
function paginateAnything(arrayOfThings) {
    return {
        content: arrayOfThings,
        empty: !arrayOfThings.length,
        first: true,
        last: true,
        number: 0,
        numberOfElements: arrayOfThings.length,
        size: 20,
        sort: {
            empty: !arrayOfThings.length,
            sorted: true,
            unsorted: false,
        },
        totalElements: arrayOfThings.length,
        totalPages: 1,
        pageable: {
            sort: {
                empty: !arrayOfThings.length,
                sorted: true,
                unsorted: false,
            },
            offset: 0,
            pageSize: 20,
            pageNumber: 0,
            paged: true,
            unpaged: false,
        },
    };
}
exports.paginateAnything = paginateAnything;
//# sourceMappingURL=paginateAnything.js.map